/**
 * Extract whitelist array.
 */
export function whitelistTransform(whitelistObject) {
    return whitelistObject && whitelistObject.whitelist;
}
